// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-hover:hover {
    background-color: #bfbfbf;
    background-color: #ececec;
  }
  .filtros {
    background-color: rgb(220, 220, 220);
    padding: 10px;
    border-radius: 3px;
  }
  /* Reducir el tamaño de los elementos */
  .dataTables_wrapper .dataTables_filter input {
    height: 30px;
    font-size: 14px;
  }
  
  .dataTables_wrapper .dataTables_length select {
    height: 30px;
    font-size: 14px;
  }
  
  .dataTables_wrapper .pagination .paginate_button {
    padding: 0.3rem 0.6rem;
    font-size: 14px;
  }
  
  /* issue board */
  /* Personalización del colapso horizontal */
  .collapse-horizontal {
    width: 100vw;
    max-width: 101%; /* Define el tamaño máximo cuando está expandido */
    overflow: hidden;
    transition: max-width 0.4s ease; /* Anima el ancho */
  }
    
  .collapse-horizontal:not(.show) {
    max-width: 0; /* Colapsa el ancho */
  }
  .h-110 {
    height: 110vh;
  }  
  
  /* Diseño para tabs */
  .nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active {
    color: #ffffff;
    background-color: #d43c00;
    border-color: #d43c00 #d43c00 #d43c00;
  
    background-color: #bc0000;
    border-color: #bc0000 #bc0000 #bc0000;
  }
  .nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link {
    /* color: #ffffff; */
    color: #d43c00;
    color: #bc0000;
    /* border-color: #d43c00 #d43c00 #d43c00; */
  }
  .nav-tabs {
    border-bottom: 1px solid #bc0000;
  }
  
  .scrollable-container {
    max-height: 500px; /* Altura máxima de 200px */
    overflow-y: auto; /* Permite desplazamiento vertical si el contenido excede la altura */
    border: 1px solid #e1e1e1; /* Opcional: agregar un borde para visualizar mejor */
    padding-right: 10px; /* Opcional: espacio al final del scroll */
  }


  .circuito-container {
    display: inline-flex;
    align-items: center;
    background-color: #b50000; /* Rojo oscuro */
    color: white;
    padding: 5px 10px;
    border-radius: 5px;
  }
  .circuito-label {
    font-size: 14px;
    margin: 0 5px;
  }
  .circuito-select {
    width: 50px;
    font-size: 14px;
    text-align: center;
    border: none;
    border-radius: 3px;
  }

  .circuito {
    border-left: 5px solid #b50000;;
  }
    /* Acordeón vertical en pantallas pequeñas */
  @media (max-width: 991px) {
    .collapse-horizontal {
      width: 100%;
      max-height: 0;
      transition: max-height 0.4s ease; /* Animación de colapso vertical */
      overflow: hidden;
    }
  
    .collapse-horizontal.show {
      max-height: 100%; 
    }
  
    .collapse-horizontal:not(.show) {
      max-height: 0;
    }
  
    /* Flecha izquierda/derecha para pantallas grandes */
    /* .fa-chevron-up, .fa-chevron-down {
      display: none;
    } */
  }
  
  /* Flecha arriba/abajo para pantallas pequeñas */
  /* @media (max-width: 767px) {
    .fa-chevron-left, .fa-chevron-right {
      display: none;
    }
  } */
  
    `, "",{"version":3,"sources":["webpack://./src/app/modules/trainer-dashboard/constructor-rutinas/constructor-rutinas.component.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,yBAAyB;EAC3B;EACA;IACE,oCAAoC;IACpC,aAAa;IACb,kBAAkB;EACpB;EACA,uCAAuC;EACvC;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,eAAe;EACjB;;EAEA,gBAAgB;EAChB,2CAA2C;EAC3C;IACE,YAAY;IACZ,eAAe,EAAE,kDAAkD;IACnE,gBAAgB;IAChB,+BAA+B,EAAE,mBAAmB;EACtD;;EAEA;IACE,YAAY,EAAE,qBAAqB;EACrC;EACA;IACE,aAAa;EACf;;EAEA,qBAAqB;EACrB;IACE,cAAc;IACd,yBAAyB;IACzB,qCAAqC;;IAErC,yBAAyB;IACzB,qCAAqC;EACvC;EACA;IACE,oBAAoB;IACpB,cAAc;IACd,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,gCAAgC;EAClC;;EAEA;IACE,iBAAiB,EAAE,2BAA2B;IAC9C,gBAAgB,EAAE,qEAAqE;IACvF,yBAAyB,EAAE,qDAAqD;IAChF,mBAAmB,EAAE,0CAA0C;EACjE;;;EAGA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,yBAAyB,EAAE,gBAAgB;IAC3C,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,aAAa;EACf;EACA;IACE,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,8BAA8B;EAChC;IACE,4CAA4C;EAC9C;IACE;MACE,WAAW;MACX,aAAa;MACb,gCAAgC,EAAE,kCAAkC;MACpE,gBAAgB;IAClB;;IAEA;MACE,gBAAgB;IAClB;;IAEA;MACE,aAAa;IACf;;IAEA,oDAAoD;IACpD;;OAEG;EACL;;EAEA,gDAAgD;EAChD;;;;KAIG","sourcesContent":[".table-hover:hover {\n    background-color: #bfbfbf;\n    background-color: #ececec;\n  }\n  .filtros {\n    background-color: rgb(220, 220, 220);\n    padding: 10px;\n    border-radius: 3px;\n  }\n  /* Reducir el tamaño de los elementos */\n  .dataTables_wrapper .dataTables_filter input {\n    height: 30px;\n    font-size: 14px;\n  }\n  \n  .dataTables_wrapper .dataTables_length select {\n    height: 30px;\n    font-size: 14px;\n  }\n  \n  .dataTables_wrapper .pagination .paginate_button {\n    padding: 0.3rem 0.6rem;\n    font-size: 14px;\n  }\n  \n  /* issue board */\n  /* Personalización del colapso horizontal */\n  .collapse-horizontal {\n    width: 100vw;\n    max-width: 101%; /* Define el tamaño máximo cuando está expandido */\n    overflow: hidden;\n    transition: max-width 0.4s ease; /* Anima el ancho */\n  }\n    \n  .collapse-horizontal:not(.show) {\n    max-width: 0; /* Colapsa el ancho */\n  }\n  .h-110 {\n    height: 110vh;\n  }  \n  \n  /* Diseño para tabs */\n  .nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active {\n    color: #ffffff;\n    background-color: #d43c00;\n    border-color: #d43c00 #d43c00 #d43c00;\n  \n    background-color: #bc0000;\n    border-color: #bc0000 #bc0000 #bc0000;\n  }\n  .nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link {\n    /* color: #ffffff; */\n    color: #d43c00;\n    color: #bc0000;\n    /* border-color: #d43c00 #d43c00 #d43c00; */\n  }\n  .nav-tabs {\n    border-bottom: 1px solid #bc0000;\n  }\n  \n  .scrollable-container {\n    max-height: 500px; /* Altura máxima de 200px */\n    overflow-y: auto; /* Permite desplazamiento vertical si el contenido excede la altura */\n    border: 1px solid #e1e1e1; /* Opcional: agregar un borde para visualizar mejor */\n    padding-right: 10px; /* Opcional: espacio al final del scroll */\n  }\n\n\n  .circuito-container {\n    display: inline-flex;\n    align-items: center;\n    background-color: #b50000; /* Rojo oscuro */\n    color: white;\n    padding: 5px 10px;\n    border-radius: 5px;\n  }\n  .circuito-label {\n    font-size: 14px;\n    margin: 0 5px;\n  }\n  .circuito-select {\n    width: 50px;\n    font-size: 14px;\n    text-align: center;\n    border: none;\n    border-radius: 3px;\n  }\n\n  .circuito {\n    border-left: 5px solid #b50000;;\n  }\n    /* Acordeón vertical en pantallas pequeñas */\n  @media (max-width: 991px) {\n    .collapse-horizontal {\n      width: 100%;\n      max-height: 0;\n      transition: max-height 0.4s ease; /* Animación de colapso vertical */\n      overflow: hidden;\n    }\n  \n    .collapse-horizontal.show {\n      max-height: 100%; \n    }\n  \n    .collapse-horizontal:not(.show) {\n      max-height: 0;\n    }\n  \n    /* Flecha izquierda/derecha para pantallas grandes */\n    /* .fa-chevron-up, .fa-chevron-down {\n      display: none;\n    } */\n  }\n  \n  /* Flecha arriba/abajo para pantallas pequeñas */\n  /* @media (max-width: 767px) {\n    .fa-chevron-left, .fa-chevron-right {\n      display: none;\n    }\n  } */\n  \n    "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
